import React, { PureComponent } from "react";
import { connect } from "react-redux";
import PriceFilter from "../../components/filters/PriceFilter";
import { portalConfig } from "../../lib/portal";
import { priceValueMap } from "../../lib/filters";
import { updateFilter } from "../../actions/filter";
import PropTypes from "prop-types";
import { updateHasChangedFilter } from "../../actions/componentStatus/hasChangedFilters";

const elementId = "Price";

class PriceFilterContainer extends PureComponent {
  render() {
    const { labelPosition, maxPrice, portalId, updateFilter } = this.props;

    try {
      return (
        <PriceFilter
          currencySymbolInFront={this.portal().currencySymbolInFront}
          decimalSeparator={this.portal().decimalSeparator}
          decimalZerosReplacement={this.portal().decimalZerosReplacement}
          id={this.id()}
          componentMappedValue={maxPrice}
          labelPosition={labelPosition}
          onChangeComplete={updateFilter}
          portalId={portalId}
          replaceZeros={true}
          unicodeCurrencySymbol={this.portal().unicodeCurrencySymbol}
        />
      );
    } catch (e) {
      return null;
    }
  }

  id() {
    const { offerType } = this.props;

    return `${offerType}${elementId}`;
  }

  portal() {
    const { portalId } = this.props;
    return portalConfig(portalId);
  }
}

function mapStateToProps(state) {
  return {
    hasChangedFilter: state.componentStatus.hasChangedFilters[elementId],
    maxPrice: state.filter[state.offerType].maxPrice,
    offerType: state.offerType,
    portalId: state.portalId,
    sliderValue: state.componentStatus.sliders[`${state.offerType}${elementId}`]
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateFilter: (offerType, mappedValue) => {
      dispatch(
        updateFilter(offerType, {
          maxPrice: mappedValue
        })
      );
    },
    updateHasChangedFilter: () => {
      dispatch(updateHasChangedFilter(elementId));
    }
  };
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  const { updateFilter, updateHasChangedFilter } = dispatchProps;
  const { offerType, portalId, sliderValue } = stateProps;
  const mappedValue = priceValueMap(portalId)[sliderValue];

  return {
    ...stateProps,
    ...ownProps,
    updateFilter: () => {
      updateHasChangedFilter();
      updateFilter(offerType, mappedValue);
    }
  };
}

PriceFilterContainer.propTypes = {
  labelPosition: PropTypes.string
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(PriceFilterContainer);
